import React from "react";
import styles from "../property-detail-header/property-detail-header.module.scss";
import { useNavigate } from "react-router-dom";

const PropertyDetailHeader = ({
  address,
  
}: {
  address: string;
  
}) => {
  const navigate = useNavigate();
  return (
    <div className={styles.breadCrumbs}>
      <span
        className={styles.back}
        onClick={() => {
          navigate(-1);
        }}
      >
        <img src="/images/arrow-left.svg" alt="" /> Properties
      </span>
      <span className={styles.divider}>/</span>
      <span>{address}</span>
    </div>
  );
};

export default React.memo(PropertyDetailHeader);
